import { createStore } from 'jotai';

// Create and export a store instance that can be used both in React and outside
export const jotaiStore = createStore();
